import { getElementHeadingValue, isHTMLElement } from 'whisper-base';
import { NudgeTypes } from '../constants';
import { getNudgePropertiesFromAttributes } from '../get-nudge-properties-from-attributes';
import { isNudgeType } from '../is-nudge-type';
export const Definition = {
  selector: '[data-component-name="ModalDialog"] [role="dialog"]',
  shouldTrackRenderedForChild: ({
    parent
  }) => {
    if (
    // Effective way to filter out the transition wrapper on the showing lifecycle
    parent.matches('[data-transition-wrapper="true"]') ||
    // Following a dismissal the selector will match on what it thinks is a new element
    // However it's a side effect of the transition, only proceed if the parent is a data layer
    !parent.matches(`[data-layer-for="Modal"], [data-layer-for="ModalPanel"]`)) {
      return false;
    }
    return true;
  },
  shouldTrackDismissedForChild: ({
    parent
  }) => {
    // False match due to transition during dismissal
    if ((parent === null || parent === void 0 ? void 0 : parent.classList.length) === 0) {
      return false;
    }
    return true;
  },
  getNudgeProperties: ({
    element
  }) => {
    let properties = {
      type: NudgeTypes.MODAL,
      title: 'no-title'
    };

    // Get the title of the dialog
    const titleMaybe = getElementHeadingValue(element);
    if (titleMaybe) {
      properties.title = titleMaybe;
    }

    // Find the first parent of element which has a role of dialog
    const dialogRoot = element.closest('[data-component-name="ModalDialog"]');
    if (isHTMLElement(dialogRoot)) {
      // When the modal is used to show a nudge but type modal should be overridden
      const nudgeTypeOverrideMaybe = dialogRoot.dataset.nudgeType;
      properties = Object.assign({}, properties, isNudgeType(nudgeTypeOverrideMaybe) ? {
        type: nudgeTypeOverrideMaybe
      } : {}, getNudgePropertiesFromAttributes(dialogRoot));
    }
    return properties;
  }
};